// FT-200 (REQ-11): группы статусов операций для страницы возврата из банка (ClientResult).
//
// Оплата Stripe и Yandex Pay — status заказа (StripePayment.statuses ∪ YandexPayPayment.statuses в api):
//   ok    — оплата принята;
//   later — оплата прошла, потом изменилась (возврат, спор): деньги принимались, итог операции — «принята»;
//   fail  — не прошла;
//   wait  — банк ещё не ответил.
// Привязка карты Т-Банка — outcome платежа привязки (TinkoffPayment.outcomes; null — банк ещё не ответил):
//   ok — карта прошла проверку (списание возвращено целиком или частично), fail — не прошла, wait — ждём банк.
//
// Группы — разбиение enum моделей: каждый статус ровно в одной группе. Источник — spec/fixtures/client_cabinet/
// statuses.json в api (спек statuses_sync_spec.rb сверяет его с enum); во vue лежит побайтовая копия
// tests/unit/client_page/fixtures/statuses.json, с которой clientResult.spec.js сверяет GROUPS. Статус, которого нет в
// группах (новый у провайдера), — «банк проверяет»: успех страница показывает только по известному статусу.
//
// Модуль — часть «набора возврата» (Task 6): без Vue, стора и роутера.

export const PAYMENT_OK = ["success"];
export const PAYMENT_LATER = ["refunded", "partially_refunded", "disputed", "dispute_lost"];
export const PAYMENT_FAIL = ["failed", "cancelled"];
export const PAYMENT_WAIT = ["created", "pending"];

export const CARD_OK = ["success", "refund", "partial_refund"];
export const CARD_FAIL = ["failed"];
export const CARD_WAIT = ["unknown", "stale", null];

export const GROUPS = {
  payment: { ok: PAYMENT_OK, later: PAYMENT_LATER, fail: PAYMENT_FAIL, wait: PAYMENT_WAIT },
  card: { ok: CARD_OK, fail: CARD_FAIL, wait: CARD_WAIT },
};

// "ok" | "later" | "fail" | "wait"
export function paymentGroup(status) {
  if (PAYMENT_OK.indexOf(status) !== -1) return "ok";
  if (PAYMENT_LATER.indexOf(status) !== -1) return "later";
  if (PAYMENT_FAIL.indexOf(status) !== -1) return "fail";
  return "wait";
}

// "ok" | "fail" | "wait"
export function cardGroup(outcome) {
  if (CARD_OK.indexOf(outcome) !== -1) return "ok";
  if (CARD_FAIL.indexOf(outcome) !== -1) return "fail";
  return "wait";
}

export default { GROUPS, paymentGroup, cardGroup };
